/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'image': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M2.25 4c0-.966.784-1.75 1.75-1.75h16c.966 0 1.75.784 1.75 1.75v16A1.75 1.75 0 0120 21.75H4A1.75 1.75 0 012.25 20V4zM4 3.75a.25.25 0 00-.25.25v16c0 .138.112.25.25.25h16a.25.25 0 00.25-.25V4a.25.25 0 00-.25-.25H4zm4 4a.25.25 0 100 .5.25.25 0 000-.5zM6.25 8a1.75 1.75 0 113.5 0 1.75 1.75 0 01-3.5 0zm8.522 2.432a.75.75 0 00-.974-.005l-8.282 7a.75.75 0 10.968 1.146l7.794-6.587 3.233 2.784a.75.75 0 10.978-1.137l-3.717-3.201z" _fill="#000"/>'
  }
})
